export default {
    props: {
        charLimit: {
            type: Number,
            required: false,
            default: 200
        }
    },

    mounted() {
        this.initializeTruncatedHtml(this.$el);
    },
    
    methods: {
        initializeTruncatedHtml(element) {
            const charLimit = this.charLimit;
            const originalHTML = element.innerHTML;
            
            // Extract text content for length calculation
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = originalHTML;
            const textContent = tempDiv.textContent || tempDiv.innerText;
            
            // Only proceed if content exceeds limit
            if (textContent.length <= charLimit || charLimit == 0) {
                return;
            }
            
            // Store original content and create truncated version
            element.dataset.originalHtml = originalHTML;
            element.dataset.isExpanded = 'false';
            element.innerHTML = this.createTruncatedHTML(originalHTML, charLimit);
        },
        
        createTruncatedHTML(html, limit) {
            const temp = document.createElement('div');
            temp.innerHTML = html;
            const text = temp.textContent;
            
            if (text.length <= limit) return html;
            
            let charCount = 0;
            let truncatedHTML = '';
            let inTag = false;
            
            for (let i = 0; i < html.length; i++) {
                const char = html[i];
                
                if (char === '<') {
                    inTag = true;
                    truncatedHTML += char;
                } else if (char === '>') {
                    inTag = false;
                    truncatedHTML += char;
                } else if (!inTag) {
                    if (charCount < limit) {
                        truncatedHTML += char;
                        charCount++;
                    } else {
                        truncatedHTML += '... <button class="read-more-btn" data-toggle="read-more">Read More</button>';
                        break;
                    }
                } else {
                    truncatedHTML += char;
                }
            }
            
            return truncatedHTML;
        },
        
        createExpandedHTML(html) {
            return html + ' <button class="read-more-btn" data-toggle="read-more">Read Less</button>';
        },
        
        handleToggle(event) {
            if (!event.target.matches('[data-toggle="read-more"]')) return;
            
            const button = event.target;
            const container = button.closest('[data-truncated-html]');
            const isExpanded = container.dataset.isExpanded === 'true';
            const originalHTML = container.dataset.originalHtml;
            const charLimit = this.charLimit;
            
            if (isExpanded) {
                // Collapse
                container.innerHTML = this.createTruncatedHTML(originalHTML, charLimit);
                container.dataset.isExpanded = 'false';
            } else {
                // Expand
                container.innerHTML = this.createExpandedHTML(originalHTML);
                container.dataset.isExpanded = 'true';
            }
        }
    },
    
    created() {
        // Add event delegation for dynamically created buttons
        document.addEventListener('click', this.handleToggle);
    },
    
    beforeDestroy() {
        // Clean up event listener
        document.removeEventListener('click', this.handleToggle);
    }
}